import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

export default function AccordionExpandIcon({
	title,
	children,
	index,
	expanded,
	handleAccordionChange,
}: any) {
	return (
		<Accordion
			disableGutters
			style={{
				backgroundColor: "#FAFAFA",
				boxShadow: "none",
			}}
			expanded={expanded === index}
			onChange={handleAccordionChange(index)}
		>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
			<AccordionDetails sx={{ flexDirection: "column", borderTop: "1px solid #E8E8E8" }}>
				{children}
			</AccordionDetails>
		</Accordion>
	);
}
